import { useQuery } from 'react-query';

const fetchLookup = ({
  email,
  domain,
}: {
  email?: string;
  domain?: string;
}): Promise<any | undefined> => {
  const data = { email, domain };

  return fetch(`/v1/lookup`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  }).then((res) => res.json());
};

const usePersonLookup = (email: string) => {
  const { data, isLoading, isError, refetch } = useQuery(
    ['person_lookup', email],
    () => fetchLookup({ email }),
  );

  // TODO: Handle pending requests
  // useEffect(() => {
  //   if (data && data.error && data.error.type === 'pending') {
  //     setTimeout(() => {
  //       refetch();
  //     }, 2000);
  //   }
  // }, [data]);

  return {
    data,
    isLoading,
    isError: isError || (data && !data.data),
    refetch,
  };
};

const useCompanyLookup = (domain: string) => {
  const { data, isLoading, isError, refetch } = useQuery(
    ['company_lookup', domain],
    () => fetchLookup({ domain }),
  );

  // TODO: Handle pending requests
  // useEffect(() => {
  //   if (data && data.error && data.error.type === 'pending') {
  //     setTimeout(() => {
  //       refetch();
  //     }, 2000);
  //   }
  // }, [data]);

  return {
    data,
    isLoading,
    isError: isError || (data && !data.data),
    refetch,
  };
};

export { useCompanyLookup, usePersonLookup };
